// extracted by mini-css-extract-plugin
export default {"wrapper":"contents_wrapper__RZWRF","textBox":"contents_textBox__rOoTx"};